// import { NAMESPACE as ParentNamespace } from '@/app/weekly_sales/store/Index'
import { Types as TypesModule } from '@/app/weekly_sales/store/Index'

// import { Types as TypesDateGranularity } from '@/app/sales_analysis/store/DateGranularity'
import filters, { Types as TypesFilters } from '@/app/shared/store/modules/Filters'
import breadCrumb, { Types as TypesBreadCrumb } from '@/app/shared/store/modules/BreadCrumb'

import { getWeeklyGrid } from '@/app/weekly_sales/Services'
import { addNamespace } from '@/app/shared/utils/NamespaceHelper'

const BREADCRUMB_MODULE_NAME = 'breadCrumb'
const NAMESPACE = 'weeklySales/weeklyComparative/'
const NAMESPACE_BREADCRUMB = NAMESPACE + BREADCRUMB_MODULE_NAME + '/'

const _types = {
  getters: {
    PIVOT_DIMENSIONS: 'GETTER_PIVOT_DIMENSIONS',
    DIMENSION_TO_FILTER: 'GETTER_DIMENSION_TO_FILTER',
    DEFAULT_DIMENSION: 'GETTER_DEFAULT_DIMENSION',
    PIVOTED_FILTERS: 'GETTER_PIVOTED_FILTERS',
    PIVOTED_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_FILTER_DIMENSION_IDS',
    HAS_SELECTED_FILTERS: 'GETTER_HAS_SELECTED_FILTERS',
    BASE_DIMENSION: 'BASE_DIMENSION',
    LAST_BREADCRUMB_ITEM: 'LAST_BREADCRUMB_ITEM',
    LAST_THREE_YEARS: 'LAST_THREE_YEARS',
    DATE_FILTERS: 'DATE_FILTERS'
  },
  actions: {
    INIT: 'INIT',
    INIT_BREADCRUMB: 'INIT_BREADCRUMB',
    INIT_FILTERS: 'INIT_FILTERS',
    INIT_DIMENSION: 'INIT_DIMENSION',
    INIT_YEAR: 'INIT_YEAR',
    INIT_WEEKLY_COMPARATIVE_GRID: 'INIT_WEEKLY_COMPARATIVE_GRID',
    FETCH_WEEKLY_COMPARATIVE_GRID: 'FETCH_WEEKLY_COMPARATIVE_GRID',
    PUSH_BREADCRUMB_ITEM: 'PUSH_BREADCRUMB_ITEM',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    APPLY_FILTERS: 'APPLY_FILTERS',
    DOWNLOAD_EXCEL: 'DOWNLOAD_EXCEL',
    RESET: 'RESET',
    CHANGE_YEAR: 'CHANGE_YEAR',
    CHANGE_METRIC: 'CHANGE_METRIC'
  },
  mutations: {
    SET_YEAR: 'SET_YEAR',
    SET_GRID: 'SET_GRID'
  }
}
export const Types = addNamespace(NAMESPACE, _types)

const WeeklyComparative = {
  namespaced: true,
  state: {
    grid: null,
    metrics: null,
    year: null
  },
  getters: {
    [_types.getters.DEFAULT_DIMENSION]: (state, getters, rootState, rootGetters) => {
      const dimensions = rootState.weeklySales.dimensions
      return dimensions.find((dimension) => dimension.selected) || dimensions[0]
      // return rootState.weeklySales.dimensions[0]
    },
    [_types.getters.PIVOT_DIMENSIONS]: (state, getters, rootState, rootGetters) => {
      const dimensionIdsInBreadCrumb = rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_IDS_IN_BREADCRUMB]
      const dimensionsToPivot = (dimension) => !dimensionIdsInBreadCrumb.includes(dimension.id)
      return rootState.weeklySales.dimensions.filter(dimensionsToPivot)
    },
    [_types.getters.PIVOTED_FILTERS]: (state) => {
      return state.breadCrumb.items.filter((breadcrumbItem) => breadcrumbItem.filter)
        .map((breadcrumbItem) => breadcrumbItem.filter)
    },
    [_types.getters.PIVOTED_FILTER_DIMENSION_IDS]: (state, getters) => {
      return getters[_types.getters.PIVOTED_FILTERS].map((pivotedFilter) => pivotedFilter.keyField)
    },
    [_types.getters.HAS_SELECTED_FILTERS]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE + TypesFilters.getters.HAS_SELECTED_FILTERS]
    },
    [_types.getters.DIMENSION_TO_FILTER]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]
    },
    [_types.getters.BASE_DIMENSION]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.FIRST_ITEM].dimension
    },
    [_types.getters.LAST_BREADCRUMB_ITEM]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
    },
    [_types.getters.LAST_THREE_YEARS]: (_) => {
      const currentYear = new Date().getFullYear()
      return [currentYear, currentYear - 1, currentYear - 2]
    },
    [_types.getters.DATE_FILTERS]: (state, getters, rootState, rootGetters) => (year) => {
      const currentYear = new Date().getFullYear()
      let yearWeeklyTarget = null
      if (year === currentYear) {
        yearWeeklyTarget = rootGetters.thisYearWeekly
      } else if (year === currentYear - 1) {
        yearWeeklyTarget = rootGetters.lastYearWeekly
      } else if (year === currentYear - 2) {
        yearWeeklyTarget = rootGetters.lastLastYearWeekly
      }
      const { startDate, endDate } = yearWeeklyTarget
      return { date: { operator: 'BT', value: [startDate, endDate] } }
    }
  },
  actions: {
    [_types.actions.INIT] ({ commit, dispatch, getters }) {
      dispatch(_types.actions.INIT_FILTERS)
      dispatch(_types.actions.INIT_YEAR)
      dispatch(_types.actions.INIT_BREADCRUMB, getters[_types.getters.DEFAULT_DIMENSION])
      dispatch(_types.actions.INIT_WEEKLY_COMPARATIVE_GRID)
    },
    [_types.actions.INIT_FILTERS] ({ dispatch, rootState }) {
      const storeFilters = { ...rootState.weeklySales.filters.selectedStoreFilters }
      const productFilters = { ...rootState.weeklySales.filters.selectedProductFilters }
      dispatch(NAMESPACE + TypesFilters.actions.SET_SELECTED_FILTERS, { storeFilters, productFilters }, { root: true })
    },
    [_types.actions.INIT_YEAR] ({ commit }) {
      commit(_types.mutations.SET_YEAR, new Date().getFullYear())
    },
    [_types.actions.INIT_BREADCRUMB] ({ dispatch, commit, state, getters }, dimension) {
      commit(NAMESPACE_BREADCRUMB + TypesBreadCrumb.mutations.RESET, null, { root: true })
      const breadCrumbItemText = dimension.value
      commit(NAMESPACE_BREADCRUMB + TypesBreadCrumb.mutations.PUSH_ITEM, { dimension, filter: undefined, text: breadCrumbItemText }, { root: true })
    },
    async [_types.actions.INIT_WEEKLY_COMPARATIVE_GRID] ({ state, dispatch, getters, rootState }) {
      const dimension = getters[_types.getters.DEFAULT_DIMENSION]
      const dateFilters = getters[_types.getters.DATE_FILTERS](state.year)
      const normalMetric = rootState.weeklySales.metric
      await dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, { normalMetric, dimension, dateFilters })
    },
    async [_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID] ({ rootState, commit }, { normalMetric, dimension, filter, dateFilters }) {
      commit(_types.mutations.SET_GRID, null)
      const { filters } = rootState.weeklySales
      const weeklyComparativeGrid = await getWeeklyGrid({ normalMetric, dimension, strategyFilter: filter, filters, dateFilters, dateDimensions: ['calendarweek'] })
      commit(_types.mutations.SET_GRID, weeklyComparativeGrid)
    },
    // TODO: Refactor, I don't like the if
    async [_types.actions.PUSH_BREADCRUMB_ITEM] ({ commit, dispatch, rootState }, { dimension, filter, breadCrumbItemText, dateFilter }) {
      const normalMetric = rootState.weeklySales.metric
      await dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, { normalMetric, dimension, filter, dateFilter })
      commit(NAMESPACE_BREADCRUMB + TypesBreadCrumb.mutations.PUSH_ITEM, { dimension, filter, text: breadCrumbItemText }, { root: true })
    },
    [_types.actions.CHANGE_PIVOT] ({ getters, dispatch, rootGetters }, { pivotedDimensionId, pivotedDimensionCellValue, filter }) {
      const dimension = rootGetters[TypesModule.getters.DIMENSION_BY_ID](pivotedDimensionId)
      const breadCrumbItemText = `${dimension.value} en ${pivotedDimensionCellValue}`
      dispatch(_types.actions.PUSH_BREADCRUMB_ITEM, { dimension, filter, breadCrumbItemText })
    },
    // TODO: Refactor, too much code in here!
    async [_types.actions.POP_UNTIL_BREADCRUMB] ({ state, commit, dispatch, rootGetters }, breadCrumbItem) {
      if (rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM] === breadCrumbItem) return
      while (rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM] !== breadCrumbItem) {
        const lastBreadCrumbItem = rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
        commit(NAMESPACE_BREADCRUMB + TypesBreadCrumb.mutations.REMOVE_ITEM, lastBreadCrumbItem, { root: true })
        dispatch(NAMESPACE + TypesFilters.actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbItem.filter, { root: true })
      }
      await dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, breadCrumbItem)
    },
    // TODO: Refactor, too much code in here!
    [_types.actions.CHANGE_BASE_DIMENSION] ({ state, dispatch, rootGetters, getters, rootState }, dimensionId) {
      const dimension = rootGetters[TypesModule.getters.DIMENSION_BY_ID](dimensionId)
      const pivotedFilters = getters[_types.getters.PIVOTED_FILTERS]
      const normalMetric = rootState.weeklySales.metric
      const dateFilters = getters[_types.getters.DATE_FILTERS](state.year)
      pivotedFilters.forEach((pivotedFilter) => {
        dispatch(NAMESPACE + TypesFilters.actions.REMOVE_SELECTED_FILTER_IN_CASCADE, pivotedFilter, { root: true })
      })
      dispatch(_types.actions.INIT_BREADCRUMB, dimension)
      dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, { normalMetric, dimension, dateFilters })
    },
    [_types.actions.APPLY_FILTERS] ({ state, dispatch, getters, rootGetters, rootState }) {
      const { dimension, filter } = rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
      const normalMetric = rootState.weeklySales.metric
      const dateFilters = getters[_types.getters.DATE_FILTERS](state.year)
      dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, { normalMetric, dimension, filter, dateFilters })
    },
    [_types.actions.RESET] ({ commit }) {
      commit(NAMESPACE_BREADCRUMB + TypesBreadCrumb.mutations.RESET, null, { root: true })
      commit(_types.mutations.SET_GRID, null)
    },
    async [_types.actions.CHANGE_YEAR] ({ commit, dispatch, getters, rootGetters, rootState }, year) {
      const { dimension, filter } = rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
      const dateFilters = getters[_types.getters.DATE_FILTERS](year)
      const normalMetric = rootState.weeklySales.metric
      await dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, { normalMetric, dimension, filter, dateFilters })
      commit(_types.mutations.SET_YEAR, year)
    },
    async [_types.actions.CHANGE_METRIC] ({ state, commit, dispatch, getters, rootGetters }, normalMetric) {
      const { dimension, filter } = rootGetters[NAMESPACE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
      const dateFilters = getters[_types.getters.DATE_FILTERS](state.year)
      await dispatch(_types.actions.FETCH_WEEKLY_COMPARATIVE_GRID, { normalMetric, dimension, filter, dateFilters })
    }
  },
  mutations: {
    [_types.mutations.SET_GRID] (state, longGrid) {
      state.grid = longGrid
    },
    [_types.mutations.SET_YEAR] (state, year) {
      state.year = year
    }
  },
  modules: {
    filters,
    [BREADCRUMB_MODULE_NAME]: breadCrumb
  }
}

export default WeeklyComparative



// WEBPACK FOOTER //
// ./src/app/weekly_sales/store/WeeklyComparative.js